import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {UnitRatingResponse} from '../../model/unit-rating-response';
import {DrivePackageWrapperComponent} from '../drive-package-wrapper/drive-package-wrapper.component';
import {ScheduleLinePerformanceCoilOutputComponent} from '../schedule-line-performance-coil-output/schedule-line-performance-coil-output.component';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-schedule-line-performance-output',
    templateUrl: './schedule-line-performance-output.component.html',
    styleUrls: ['./schedule-line-performance-output.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ScheduleLinePerformanceCoilOutputComponent, DrivePackageWrapperComponent, DecimalPipe]
})
export class ScheduleLinePerformanceOutputComponent implements OnChanges {

  readonly response = input.required<UnitRatingResponse>();
  readonly isMetric = input.required<boolean>();
  readonly isAirHandler = input.required<boolean>();
  readonly isSureflow = input.required<boolean>();

  constructor() {
  }

  ngOnChanges() {
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.isMetric());
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric());
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.isMetric());
  }

}
